import { Injectable } from '@angular/core';
import { RidangoReduxAction, RefundableTicket, RefundMethodInterface } from '@ridango/core';




@Injectable()
export class RefundActions {

    static SET_REFUNDABLE_TICKETS_DATA = '[Refund]: Set Refundable Tickets Data';
    static TOGGLE_SELECTED_REFUNDABLE_TICKET = '[Refund]: Toggle selected refundable ticket';

    static SET_SELECTED_REFUND_METHOD = '[Refund]: Set selected method';

    static RESET_REFUNDABLE_TICKETS_DATA = '[Refund]: Reset Refundable Tickets Data';

    static SET_REFUND_PROGRESS = '[Refund]: Set progress';
    static INCREASE_REFUND_PROGRESS = '[Refund]: Increase progress';
    static DECREASE_REFUND_PROGRESS = '[Refund]: Decrease progress';


    static SET_SELECTED_METHOD_DATA = '[Refund]: Set selected method data';
    static SET_SELECTED_METHOD_CARD_NUMBER = '[Refund]: Set selected method card number';

    static SET_AGREEMENT = '[Refund]: Set agreement';

    static SET_AVAILABLE_CARDS = '[Refund]: Set available cards';

    static SET_SELECTED_REFUND_METHOD_VALIDITY = '[Refund]: Set selected method validity';

    static SET_REFUND_RESULT = '[Refund]: Set refund result';


    static SET_REFUND_FEE = '[Refund]: Set refund fee';

    setData ( all: RefundableTicket[], normalized: any, docNums: number[], nonRefundableDocNums: number[], cards: string[] ): RidangoReduxAction {
        return {
            type: RefundActions.SET_REFUNDABLE_TICKETS_DATA,
            payload: {
                all: all,
                normalized: normalized,
                docNums: docNums,
                nonRefundableDocNums: nonRefundableDocNums,
                cards: cards
            }
        };
    }
    toggleSelected ( ticket: RefundableTicket ): RidangoReduxAction {
        return {
            type: RefundActions.TOGGLE_SELECTED_REFUNDABLE_TICKET,
            payload: ticket
        };
    }
    setSelectedRefundMethod ( method: RefundMethodInterface ): RidangoReduxAction {
        return {
            type: RefundActions.SET_SELECTED_REFUND_METHOD,
            payload: method
        };
    }
    increaseProgress (): RidangoReduxAction {
        return {
            type: RefundActions.INCREASE_REFUND_PROGRESS
        };
    }
    decreaseProgress (): RidangoReduxAction {
        return {
            type: RefundActions.DECREASE_REFUND_PROGRESS
        };
    }
    setProgress ( step: number ): RidangoReduxAction {
        return {
            type: RefundActions.SET_REFUND_PROGRESS,
            payload: step
        };
    }
    reset (): RidangoReduxAction {
        return {
            type: RefundActions.RESET_REFUNDABLE_TICKETS_DATA
        };
    }

    setSelectedMethodData ( data: RefundMethodInterface ): RidangoReduxAction {
        return {
            type: RefundActions.SET_SELECTED_METHOD_DATA,
            payload: data
        };
    }
    setSelectedMethodCardNumber ( cardNumber: string ): RidangoReduxAction {

        return {
            type: RefundActions.SET_SELECTED_METHOD_CARD_NUMBER,
            payload: cardNumber
        };
    }
    setAgreement ( agreement: boolean ): RidangoReduxAction {
        return {
            type: RefundActions.SET_AGREEMENT,
            payload: agreement
        };
    }
    setAvailableCards ( cards: number[] ): RidangoReduxAction {
        return {
            type: RefundActions.SET_AVAILABLE_CARDS,
            payload: cards
        };
    }
    setSelectedMethodValidity ( validity: boolean ): RidangoReduxAction {
        return {
            type: RefundActions.SET_SELECTED_REFUND_METHOD_VALIDITY,
            payload: validity
        };
    }

    setRefundResult ( cart: any, nonRefunded: RefundableTicket[] ): RidangoReduxAction {
        return {
            type: RefundActions.SET_REFUND_RESULT,
            payload: {
                cart: cart,
                nonRefunded: nonRefunded
            }
        };
    }



    setRefundFee ( fee: number ): RidangoReduxAction {
        return {
            type: RefundActions.SET_REFUND_FEE,
            payload: fee
        };
    }
}
